import { render } from "./Info.vue?vue&type=template&id=ee5c9c3a"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
script.render = render

export default script